import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchMyPrefs,
  fetchNotifications,
  fetchUnreadCount,
  markAllRead,
  markOneRead,
  notificationKeys,
  updateMyPrefs,
  type NotificationPrefs,
} from '../api';

export function useNotifications(limit = 30) {
  return useQuery({
    queryKey: [...notificationKeys.list(), limit],
    queryFn: () => fetchNotifications(limit),
    staleTime: 15_000,
    refetchInterval: 60_000, // polling cada minuto
  });
}

export function useUnreadCount() {
  return useQuery({
    queryKey: notificationKeys.unreadCount(),
    queryFn: fetchUnreadCount,
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}

export function useMarkAllRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: markAllRead,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
}

export function useMarkOneRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: markOneRead,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
}

export function useNotificationPrefs() {
  return useQuery({
    queryKey: notificationKeys.prefs(),
    queryFn: fetchMyPrefs,
    staleTime: 60_000,
  });
}

export function useUpdatePrefs() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: Partial<NotificationPrefs>) => updateMyPrefs(patch),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: notificationKeys.prefs() });
    },
  });
}
